import React from "react";

const pStyles = {
    reports: {
        reportLine: {
            display: "flex",
            width: "100%",
            flexFlow: "row",
            paddingLeft: 20,
            paddingTop: 10,
            paddingBottom: 10,
            paddingRight: 20,
            marginBottom: 10,
            color: "white",
            flexWrap: "wrap",
            alignItems: "center",
            backgroundColor: "#555566",
            justifyContent: "space-between",
            borderRadius: 40
        },

        reportLineContent: {
            display: "flex",
            flexFlow: "row",
            color: "white",
            flexWrap: "wrap",
            minWidth: 500,
            maxWidth: 500,
            alignItems: "center",
            justifyContent: "start",
            borderRadius: 40
        }
    },

};

export default pStyles;